<div class="data_card">
    <div class="general leon">
        <div class="avatar_container">
            <img class="avatar" alt="Leon Avatar" src="../../../../assets/img/leon-head-50x50.webp">
        </div>
        <div class="personal_info">
            <p style="font-weight: bold;">Leon</p>
            <p>Zimmermann</p>
        </div>
        <div class="age_info">
            <p style="font-weight: bold;">Alter</p>
            <p>{{age}}</p>
        </div>
    </div>
    <div class="infos">
        <div class="line">
            <p style="font-weight: bold;">Jobrole</p>
            <p>Dynamics 365 Entwickler</p>
        </div>
        <div class="line">
            <p style="font-weight: bold;">Company</p>
            <p>Arvato Systems Digital GmbH</p>
        </div>
        <div class="line">
            <p style="font-weight: bold;">Level</p>
            <p>Advanced</p>
        </div>
        <div class="line">
            <p style="font-weight: bold;">Entry</p>
            <p>Februar 2022</p>
        </div>                            
    </div>
</div>